/**
 * Which side of the portal an event reaches, as the Events tab says it.
 *
 * @link ../../../../../../backend/notifications/audience_reach.py for where the
 *   answer comes from.
 */

/** Which side of the portal an event ends up with. */
export type EventReach = 'customer' | 'supplier' | 'both';

/** What the Events tab's side filter can narrow to. */
export type EventSideFilter = 'all' | 'customer' | 'supplier';

export const REACH_LABELS: Record<EventReach, string> = {
  customer: 'Customer',
  supplier: 'Supplier',
  both: 'Both sides',
};

/** Hover text on a side, for what a change to that row means. */
export const REACH_HINTS: Record<EventReach, string> = {
  customer: 'Goes to the customer side only.',
  supplier: 'Goes to the supplier side only.',
  both: 'Goes to both sides, or to whichever side did not act. A change here applies to both.',
};
